import React, { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const SelectBox = ({
  value_text = [], // array
  value_id = [], // array
  setvalue_text = [], // array
  setvalue_id = [], // array
  array_list = [], // array
  placeholder_text, // string
  setValidation, // string
  isMulti, // boolean
  isTextArea, // boolean
  code,
  ownerData, //boolean

}) => {
  const [dropDown, setDropDown] = useState(false);
  const [selectALL, setSelectALL] = useState(false);
  const [list, setList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loader, setLoader] = useState(false)

  // console.log('array_list', array_list)

  useEffect(() => {
    setList(array_list);
  }, [array_list]);

  const allSelectSub = () => {
    let listId = [];
    let listName = [];
    if (selectALL) {
      array_list?.map((item, ind) => {
        listId.push(item?.id);
        listName.push(item?.name);
        setValidation(item?.id);
      });

      setvalue_id(listId);
      setvalue_text(listName);
    } else {
      setvalue_id(listId);
      setvalue_text(listName);
    }
    setSearchValue("");
  };

  const searchSub = (event) => {
    let temp = [...array_list];
    let search = temp.filter((value) =>
      value?.name?.toLowerCase()?.includes(event?.toLowerCase())
    );

    if (event?.length > 0) {
      setList(search);
    } else {
      setList(array_list);
    }

    setSearchValue(event);
  };

  const onSubSelect = (event, id, type) => {

    if (isMulti) {
      let temp = [...value_text];
      let temps = [...value_id];

      if (temp.includes(event)) {
        const listtemp = temp?.indexOf(event);
        const list = [...temp];
        list.splice(listtemp, 1);
        setvalue_text(list);
      } else {
        setvalue_text([...temp, event]);
      }

      if (temps.includes(id)) {
        const listtemp = temps.indexOf(id);
        const list = [...temps];
        list.splice(listtemp, 1);
        setvalue_id(list);
      } else {
        setvalue_id([...temps, id]);
      }
    } else {
      let temp = [];
      let temps = [];


      if (temp.includes(event)) {

        const listtemp = temp?.indexOf(event);
        const list = [...temp];
        list.splice(listtemp, 1);
        setvalue_text(list);
      } else {
        if (ownerData) {
          let filtertedData = array_list.filter((item) => item.id == id)
          console.log('fitertedData', filtertedData)
          setvalue_text(filtertedData)
        } else {
          setvalue_text([...temp, event]);
        }

      }

      if (temps.includes(id)) {

        const listtemp = temps.indexOf(id);
        const list = [...temps];
        list.splice(listtemp, 1);
        setvalue_id(list);
      } else {
        setvalue_id([...temps, id]);
      }
    }

    if (type !== "check") {
      setDropDown(false);
    }

    setSearchValue("");
    setList(array_list);
    setValidation(id);
  };

  return (
    <div className="position-relative">
      {isTextArea ? (
        <textarea
          placeholder="Select..."
          type="text"
          // value={
          //   value_text?.length > 0 ? value_text?.join(", ") : placeholder_text
          // }
          value={"Select..."}
          onClick={() => {
            setDropDown(!dropDown);
          }}
          className="input-pop-new w-100 cp rounded-3 p-2 w-90 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 p-cust"
        />
      ) : (
        <input
          placeholder="Select..."
          type="text"
          // value={
          //   value_text?.length > 0 ? value_text?.join(", ") : placeholder_text
          // }
          value={!code ? "Select..." : value_text?.length > 0 ? value_text?.join(", ") : placeholder_text}
          onClick={() => {
            setDropDown(!dropDown);
          }}
          className="input-pop w-100 cp rounded-3  p-2 w-90 fs-xs-11 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16 p-cust"
        />
      )}
      <button
        className="drop_down cust-btn"
        style={{ top: "0%" }}
        onClick={() => {
          setDropDown(!dropDown);
        }}
      >
        <KeyboardArrowDownIcon />
      </button>
      {dropDown && (
        <div
          className="invisible-cont2 z-0"
          onClick={() => {
            setDropDown(false);
          }}
        />
      )}
      <div
        className={`${dropDown ? "submenu_1 py-2" : ""
          } submenu_cont_1 overflow-scroll z-3`}
      >
        <div className="d-flex gap-1">
          <input
            className="d-flex ac-jb px-2 cust-btn text-start py-1 w-100 border-bottom rounded"
            placeholder="Search..."
            onChange={(e) => searchSub(e.target.value)}
            value={searchValue}
          />
          {isMulti ? (
            <button
              className="border-0 bg-transparent"
              onClick={() => {
                setSelectALL(prev => !prev);
                allSelectSub();
              }}
            >
              All
              {/* {loader && (
                <div className="spinner-border spinner-border-small primar"></div>
              )} */}
            </button>
          ) : null}
        </div>
        {list?.map((item, ind) => {
          const parts = item?.address && item?.address.split(",").map(part => part.trim());
          const lastThree = parts?.slice(-3).join(", ");

          return (
            <button
              className="d-flex cust-btn w-100 as-jb hover-cust ac-jb"
              key={ind}
            >
              <button
                className="px-2 cust-btn text-start py-1 w-100 "
                onClick={() => {
                  onSubSelect(item?.name, item?.id);
                }}

              >
                {item?.name}
                {item?.owner_id ? ` - ${item.owner_id}` : ""}
                {lastThree ? ` - ${lastThree}` : ""}

              </button>
              <button
                className="px-2 cust-btn text-start"
                style={{ fontSize: "large" }}
                onClick={() => {
                  onSubSelect(item?.name, item?.id, isMulti ? "check" : "");
                }}
              >
                {value_text?.includes(item?.name) ? (
                  <CheckCircleIcon className="primary" />
                ) : (
                  <RadioButtonUncheckedIcon className="primary" />
                )}
              </button>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SelectBox;
